export function resolvePostOpPlanBookingPriority({
  postOpSuggestion,
  phaseCadence,
  priorVisitDate,
} = {}) {
  const postOpDays = Number(postOpSuggestion?.days || 0) || null;
  const txPlanOffsetDays = Number(phaseCadence?.offsetDays || 0) || null;
  return {
    anchor: "post_op",
    doctorRequestedDays: postOpDays || txPlanOffsetDays || null,
    priorVisitDate: priorVisitDate || phaseCadence?.anchorDate || null,
    txPlanOffsetDays,
    txPlanAnchorDate: phaseCadence?.anchorDate || null,
    conflict: !!(postOpDays && txPlanOffsetDays && postOpDays !== txPlanOffsetDays),
  };
}
